import { render, staticRenderFns } from "./CamundaIncidents.vue?vue&type=template&id=f23de42e&scoped=true&"
import script from "./CamundaIncidents.vue?vue&type=script&lang=js&"
export * from "./CamundaIncidents.vue?vue&type=script&lang=js&"
import style0 from "./CamundaIncidents.vue?vue&type=style&index=0&id=f23de42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23de42e",
  null
  
)

export default component.exports